/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useNavigate } from 'react-router-dom';

import Text from 'components/Text';
import { MEDIA_QUERIES } from 'styles/constants';
import { ROUTES_FEEKAPP } from 'constants/routes';
import FriendsEating from 'assets/images/FriendsEating.webp';
import ButtonPrimary from 'components/buttons/ButtonPrimary';
import { BLACK, WHITE, BLUE_FEEK, PURPLE_FEEK } from 'styles/colors';

const styles = css`
  background: #efeeff;

  .about-image {
    width: 100%;
    aspect-ratio: 3/2;
    object-fit: cover;
  }

  .about-info {
    max-width: 100%;
    background: #efeeff;
    display: flex;
    padding: 0 100px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .about-info-title {
    color: var(--Brand-Blue-Feek, ${BLUE_FEEK});
    leading-trim: both;
    text-edge: cap;
    padding-bottom: 15px;
  }

  .about-info-text {
    color: var(--ui-20-black-out, ${BLACK});
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    padding-bottom: 45px;
  }
  .about-info-text span {
    text-decoration: underline;
  }

  .about-content {
    padding-right: 0px;
  }

  .buttonRounded {
    width: fit-content;
    white-space: nowrap;
    border-radius: 40px;
    display: flex;
    padding: 19px 30px;
    align-items: center;
    color: var(--ui-20-light-purple, #efeeff);
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%; /* 22.4px */
  }

  /* Responsive Design */
  ${MEDIA_QUERIES.mobile} {
    .about-info {
      maergin: 0px;
      text-align: center;
      justify-content: center;
      align-items: center;
      padding: 45px 0px;
      order: 1;
    }
    .about-content {
      padding-left: 0px;
      order: 2;
    }

    .about-info-title {
      font-size: 28px;
      text-align: center;
    }

    .about-info-text {
      font-size: 20px;
      text-align: center;
      padding: 0px 15px 15px 15px;
    }

    .buttonRounded {
      font-size: 12px;
      padding: 12px 20px;
    }

    .row {
      margin-right: 0px;
      margin-left: 0px;
    }
  }
`;

/**
 * FeekAbout component - displays the "About" section of the landing page
 * with an image and description of Feek's value proposition
 */
export const FeekAbout = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate(ROUTES_FEEKAPP.EXPLORE);
  };

  return (
    <div css={styles} className="mb80">
      <div className="row w-100">
        <div className="col-xl-6 col-lg-6 d-flex justify-content-center align-items-center about-content">
          <img
            src={FriendsEating}
            alt="Personas disfrutando de una comida juntas - Descubre Feek"
            className="about-image img-fluid"
            loading="lazy"
          />
        </div>
        <div className="col-xl-6 col-lg-6 about-info">
          {/* SEO heading - positioned off-screen to avoid layout shift */}
          <h2
            id="about-title"
            style={{
              position: 'absolute',
              left: '-9999px',
              width: '1px',
              height: '1px',
              overflow: 'hidden',
              clip: 'rect(0, 0, 0, 0)',
            }}
            aria-hidden="true"
          >
            Acerca de Feek - Colabora con marcas y gana recompensas
          </h2>
          <Text
            color={BLACK}
            fontSize={42}
            fontWeight={700}
            className="about-info-title"
            as="h3"
          >
            Colabora, disfruta y gana
          </Text>
          <Text
            color={BLACK}
            fontSize={32}
            className="about-info-text"
          >
            <span> Colabora con marcas</span> disfrutando beneficios
            increíbles, descubre que hacer en tu ciudad ahorrando y
            ganando recompensas a cambio de contenido orgánico.
          </Text>
          <ButtonPrimary
            strokeVariant
            className="buttonRounded aboutButton"
            color={PURPLE_FEEK}
            textProps={{ fontSize: 20, fontWeight: 500 }}
            textColor={WHITE}
            onClick={handleExploreClick}
            label="Explorar promociones"
            aria-label="Explorar promociones disponibles en Feek"
          />
        </div>
      </div>
    </div>
  );
};
